import * as actionTypes from "../actionTypes";

export const getChatHistory = payload => ({
    type: actionTypes.GET_CHAT_HISTORY, payload
});

export const setChatHistory = payload => ({
    type: actionTypes.SET_CHAT_HISTORY, payload
});

export const getCallHistory = payload => ({
    type: actionTypes.GET_CALL_HISTORY, payload
});

export const setCallHistory = payload => ({
    type: actionTypes.SET_CALL_HISTORY, payload
});

export const getVideoCallHistory = payload => ({
    type: actionTypes.GET_VIDEO_CALL_HISTORY, payload
});

export const setVideoCallHistory = payload => ({
    type: actionTypes.SET_VIDEO_CALL_HISTORY, payload
});

export const getLiveHistory = payload => ({
    type: actionTypes.GET_LIVE_HISTORY, payload
});

export const setLiveHistory = payload => ({
    type: actionTypes.SET_LIVE_HISTORY, payload
});

export const getGiftHistory = payload => ({
    type: actionTypes.GET_GIFT_HISTORY, payload
});

export const setGiftHistory = payload => ({
    type: actionTypes.SET_GIFT_HISTORY, payload
});

export const getServiceHistory = payload => ({
    type: actionTypes.GET_SERVICE_HISTORY, payload
})

export const getYatraHistory  = payload => ({
    type: actionTypes.GET_YATRA_HISTORY, payload
})